import { Dialog } from "primereact/dialog";
import { Image } from "primereact/image";

const PengisianMinyakImagePreview = (props) => {
  const { visible, onHide, data } = props;

  const gambarSpeedoMeter = data?.gambar_speedo_meter;
  const gambarBon = data?.gambar_bon;

  return (
    <Dialog
      visible={visible}
      style={{ width: "28rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={"Gambar Pengisian Minyak"}
      modal
      className={`p-fluid`}
      onHide={onHide}
    >
      <div className="col-start-start w-100 gap-4">
        <div className="col-start-start w-100 gap-1">
          <label className="font-bold text-sm text-slate-500">
            Foto Speedometer
          </label>
          {gambarSpeedoMeter ? (
            <Image
              src={gambarSpeedoMeter}
              alt="Foto Speedometer"
              className="w-full rounded"
              imageStyle={{
                width: "100%",
                maxHeight: "18rem",
                objectFit: "contain",
              }}
              preview
            />
          ) : (
            <span className="text-sm text-slate-400">Tidak ada gambar</span>
          )}
        </div>

        <div className="col-start-start w-100 gap-1">
          <label className="font-bold text-sm text-slate-500">
            Foto Bon
          </label>
          {gambarBon ? (
            <Image
              src={gambarBon}
              alt="Foto Bon"
              className="w-full rounded"
              imageStyle={{
                width: "100%",
                maxHeight: "18rem",
                objectFit: "contain",
              }}
              preview
            />
          ) : (
            <span className="text-sm text-slate-400">Tidak ada gambar</span>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default PengisianMinyakImagePreview;
